

// import React, { useState } from 'react';
// import { useAuth } from '../context/AuthContext';
// import { useNavigate } from 'react-router-dom';
// import toast from 'react-hot-toast';

// export default function LoginPage() {
//   const { login } = useAuth();
//   const navigate = useNavigate();
//   const [form, setForm] = useState({ username: '', password: '' });
//   const [loading, setLoading] = useState(false);
//   const [showPass, setShowPass] = useState(false);
//   const [error, setError] = useState('');

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setError('');
//     if (!form.username || !form.password) {
//       setError('Please enter your credentials.');
//       return;
//     }
//     setLoading(true);
//     try {
//       const user = await login(form.username, form.password);
//       toast.success(`Welcome back, ${user.name}!`);
//       navigate('/');
//     } catch (err) {
//       setError(err.response?.data?.message || 'Login failed. Please try again.');
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div className="min-h-screen bg-gradient-to-br from-primary-900 via-primary-800 to-surface-900 flex items-center justify-center p-4">
//       {/* Background blobs */}
//       <div className="absolute inset-0 overflow-hidden pointer-events-none">
//         <div className="absolute -top-40 -right-40 w-96 h-96 bg-primary-600/20 rounded-full blur-3xl" />
//         <div className="absolute -bottom-40 -left-40 w-96 h-96 bg-primary-800/30 rounded-full blur-3xl" />
//         <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-primary-700/10 rounded-full blur-3xl" />
//       </div>

//       <div className="relative w-full max-w-sm animate-fade-in">
//         {/* Logo */}
//         <div className="text-center mb-8">
//           <div className="inline-flex items-center justify-center w-16 h-16 bg-white/10 backdrop-blur-sm border border-white/20 rounded-2xl mb-4">
//             <svg viewBox="0 0 24 24" fill="none" className="w-8 h-8 text-white">
//               <path d="M15 7a4 4 0 014 4v1a4 4 0 01-4 4h-1l-1 2H8l-1-2H6a4 4 0 01-4-4v-1a4 4 0 014-4h9z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
//               <circle cx="9" cy="12" r="1" fill="currentColor" />
//               <circle cx="12" cy="12" r="1" fill="currentColor" />
//               <circle cx="15" cy="12" r="1" fill="currentColor" />
//             </svg>
//           </div>
//           <h1 className="font-display text-3xl font-bold text-white tracking-tight">GenKey</h1>
//           <p className="text-primary-200 text-sm mt-1">Secure Credential Management</p>
//         </div>

//         {/* Card */}
//         <div className="bg-white/95 backdrop-blur-xl rounded-2xl p-8 shadow-modal border border-white/50">
//           <h2 className="text-lg font-semibold text-surface-900 mb-5">Sign in to your account</h2>

//           <form onSubmit={handleSubmit} className="space-y-4">
//             <div>
//               <label className="block text-xs font-semibold text-surface-600 mb-1.5 uppercase tracking-wide">Username</label>
//               <input
//                 type="text"
//                 autoComplete="username"
//                 className="input-field"
//                 placeholder="Enter username"
//                 value={form.username}
//                 onChange={e => setForm(f => ({ ...f, username: e.target.value }))}
//               />
//             </div>

//             <div>
//               <label className="block text-xs font-semibold text-surface-600 mb-1.5 uppercase tracking-wide">Password</label>
//               <div className="relative">
//                 <input
//                   type={showPass ? 'text' : 'password'}
//                   autoComplete="current-password"
//                   className="input-field pr-10"
//                   placeholder="Enter password"
//                   value={form.password}
//                   onChange={e => setForm(f => ({ ...f, password: e.target.value }))}
//                 />
//                 <button
//                   type="button"
//                   onClick={() => setShowPass(v => !v)}
//                   className="absolute right-3 top-1/2 -translate-y-1/2 text-surface-400 hover:text-surface-600 transition-colors"
//                 >
//                   {showPass ? (
//                     <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                       <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21" />
//                     </svg>
//                   ) : (
//                     <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                       <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
//                       <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
//                     </svg>
//                   )}
//                 </button>
//               </div>
//             </div>

//             {error && (
//               <div className="flex items-center gap-2 p-3 bg-red-50 border border-red-200 rounded-lg text-sm text-red-700">
//                 <svg className="w-4 h-4 shrink-0" fill="currentColor" viewBox="0 0 20 20">
//                   <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
//                 </svg>
//                 {error}
//               </div>
//             )}

//             <button type="submit" disabled={loading} className="btn-primary w-full justify-center py-2.5 mt-2">
//               {loading ? (
//                 <>
//                   <div className="w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin" />
//                   Signing in…
//                 </>
//               ) : 'Sign In'}
//             </button>
//           </form>
//         </div>

//         <p className="text-center text-primary-300 text-xs mt-6">GenKey v1.0 • Secure Credential Storage</p>
//       </div>
//     </div>
//   );
// }


import React, { useState, useEffect, useRef } from 'react';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import api from '../utils/api';

export default function LoginPage() {
  const { ssoLogin } = useAuth();
  const navigate = useNavigate();
  const [status, setStatus] = useState('checking'); // checking | denied | authing
  const attempted = useRef(false);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get('token');

    if (!token) {
      setStatus('denied');
      return;
    }

    if (attempted.current) return; // StrictMode double-invoke guard
    attempted.current = true;

    setStatus('authing');
    (async () => {
      try {
        const user = await ssoLogin(token);
        toast.success(`Welcome, ${user.name}!`);
        window.history.replaceState({}, '', '/');
        navigate('/');
      } catch (err) {
        setStatus('denied');
      }
    })();
  }, []);

  if (status !== 'denied') {
    return (
      <div className="min-h-screen bg-gradient-to-br from-primary-900 via-primary-800 to-surface-900 flex items-center justify-center p-4">
        <div className="text-white text-sm flex items-center gap-3">
          <div className="w-5 h-5 border-2 border-white/30 border-t-white rounded-full animate-spin" />
          Verifying access…
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-primary-900 via-primary-800 to-surface-900 flex items-center justify-center p-4">
      <div className="bg-white/95 backdrop-blur-xl rounded-2xl p-8 shadow-modal border border-white/50 max-w-sm text-center">
        <h1 className="font-display text-xl font-bold text-surface-900 mb-2">Access Restricted</h1>
        <p className="text-surface-500 text-sm">
          GenKey can only be opened from the Super Admin dashboard's "Passwords" button.
        </p>
      </div>
    </div>
  );
}